import { render } from "./largeScreenM.vue?vue&type=template&id=348568a0&scoped=true"
import script from "./largeScreenM.vue?vue&type=script&lang=js"
export * from "./largeScreenM.vue?vue&type=script&lang=js"

import "./largeScreenM.vue?vue&type=style&index=0&id=348568a0&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348568a0"]])

export default __exports__